// extracted by mini-css-extract-plugin
export default {"services":"Services_services__z2Idj","masonry":"Services_masonry__o8Gs1"};